import { render, staticRenderFns } from "./ListadoMarca.vue?vue&type=template&id=d736712a&scoped=true&"
import script from "./ListadoMarca.vue?vue&type=script&lang=js&"
export * from "./ListadoMarca.vue?vue&type=script&lang=js&"
import style0 from "./ListadoMarca.vue?vue&type=style&index=0&id=d736712a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d736712a",
  null
  
)

export default component.exports